import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
// import DashBoardLayerEight from "../components/DashBoardLayerEight";
import DashBoardLayerEightTest from "../components/DashBoardLayerEightTest";

const HomePageEight = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Center Daily Report' />

        {/* DashBoardLayerEight */}
        <DashBoardLayerEightTest />
      </MasterLayout>
    </>
  );
};

export default HomePageEight;
